define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function(csiAccess, access, full, readOnly) {

	const bomAdminRoles = ['Product Specification Administrator', 'TDS - BOM Administrator'];

	const colorAdminRoles = ['Color Administrator'];
	const materialAdminRoles = ['Material Administrator'];
	const materialEditRoles = materialAdminRoles.concat(['Material Editor']);

	const materialLibraryCreatorRoles = ['Material Library Creator'];

	const productSpecAdminRoles = ['Product Specification Administrator'];
	const sustainabilityLibraryAdminRoles = ['Sustainability Library Administrator'];

	const productSpecEditRoles = productSpecAdminRoles.concat(['Product Specification Editor']);
	const productSpecLibAdminRoles = ['Product Specification Library Administrator'];
	const dataPackageAdminRoles = ['TDS - Data Package Administrator'];

	const sustainabilityAdminRoles = ['Sustainability Administrator'];
	const tdsSustainabilityProfileAdminRoles = sustainabilityAdminRoles.concat(['TDS - Sustainability Profile Administrator']);
	const tdsSustainabilityProfileCreatorRoles = tdsSustainabilityProfileAdminRoles.concat(['TDS - Sustainability Profile Creator']);

	const soRequesterRoles = ['Stock Order Administrator', 'Stock Order Requester'];
	const sourcingLibAdminRoles = ['Sourcing Library Administrator'];
	const sourcingAdminRoles = ['Sourcing Admin'];
	const sourcingRoles = ['Sourcing Viewer', 'Sourcing Admin', 'Sourcing Editor'];
	const styleSpecEditorRoles = ['Style Specification Editor'];
	const tdsBOMCreatorRoles = ['TDS - BOM Creator', 'TDS - BOM Administrator'];
	const tdsBOMEditorRoles = ['TDS - BOM Editor'];
	const styleViewerRole=['Style Viewer']
	const productSupplierOtherRoles = ['TDS - BOM Editor', 'Product Specification Viewer'];
	const productSupplierRoles = tdsBOMCreatorRoles.concat(productSpecEditRoles).concat(productSupplierOtherRoles).concat(sourcingRoles);
	const tdsBOMViewerRoles = ['TDS - BOM Viewer'].concat(tdsBOMCreatorRoles).concat(tdsBOMEditorRoles);

	csiAccess.addViewRoles({
		"_CS_Data": {
			"SustainabilityProfileTemplates": {
				"NewSustainabilityProfileTemplate": access(full(tdsSustainabilityProfileCreatorRoles)),
				"Copy": access(full(tdsSustainabilityProfileCreatorRoles)),
				"Delete": access(full(tdsSustainabilityProfileAdminRoles)),
			},
			"SustainabilityCompositionTypes": {
				"NewSustainabilityCompositionType": access(full(sustainabilityLibraryAdminRoles)),
				"Copy": access(full(sustainabilityLibraryAdminRoles)),
				"Delete": access(full(sustainabilityLibraryAdminRoles))
			}
		},
		"LibColorSpecification": {
			"LibElements": {
				"Copy": access(full(colorAdminRoles)),
				"Delete": access(full(colorAdminRoles)),
				"Move": access(full(colorAdminRoles)),
				"NewColorSpecification": access(full(colorAdminRoles))
			}
		},
		"LibMaterial": {
			"LibElements": {
				"Copy": access(full(materialAdminRoles)),
				"Delete": access(full(materialEditRoles)),
				"Move": access(full(materialEditRoles)),
				"NewMaterial": access(full(materialAdminRoles)),
				"AggregateElements": access(full(materialEditRoles), full(productSpecLibAdminRoles))
			}
		},
		"LibPrintDesign": {
			"LibElements": {
				"AggregateFromElements": access(full(colorAdminRoles)),
				"Copy": access(full(colorAdminRoles)),
				"Remove": access(full(colorAdminRoles)),
				"Move": access(full(colorAdminRoles)),
				"NewPrintDesign": access(full(colorAdminRoles))
			}
		},
		"LibSourcing": {
			"RoutingGroups": {
				"MoveDown": access(full(sourcingLibAdminRoles)),
				"MoveUp": access(full(sourcingLibAdminRoles)),
				"NewRoutingGroup": access(full(sourcingLibAdminRoles))
			}
		},
		"DataPackageContainer": {
			"DataPackages": {
				"AggregateFromPackages": access(full(productSpecEditRoles), full(dataPackageAdminRoles)),
				"NewDataPackage": access(full(productSpecEditRoles), full(dataPackageAdminRoles)),
				"NewDataPackageFromDataPackageTemplate": access(full(productSpecEditRoles), full(dataPackageAdminRoles)),
			}
		},
		"ProductBOMRevision": {
			"PartMaterials": {
				"CreateLinkedStyleBOMs": access(full(tdsBOMCreatorRoles), full(productSpecAdminRoles)),
				"MassUpdateStyleBOMs": access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditRoles)),
				"MassUpdateSharedDataSheets": access(full(tdsBOMCreatorRoles), full(tdsBOMEditorRoles), full(productSpecAdminRoles), full(productSpecEditRoles)),
				"PullFromSourceBOM": access(full(productSpecAdminRoles), full(bomAdminRoles), full(tdsBOMCreatorRoles)),
				"RemoveProductStructure": access(full(styleSpecEditorRoles)),
				"SelectProductSuppliers": access(full(productSupplierRoles)),
				"UpdateFromCostScenario": access(full(bomAdminRoles)),
				"UnlinkPartMaterialFromTheme": access(full(tdsBOMCreatorRoles), full(productSpecAdminRoles)),
				"AggregateFromStyle": access(full(tdsBOMViewerRoles)),
				"NewFromSourceBOM":access(full(tdsBOMEditorRoles) ,full(styleViewerRole)),
			},
			"HierarchicalPartMaterials": {
				"PullFromSourceBOM": access(full(productSpecAdminRoles), full(bomAdminRoles), full(tdsBOMCreatorRoles)),
				"UnlinkPartMaterialFromTheme": access(full(tdsBOMCreatorRoles), full(productSpecAdminRoles)),
				"AggregateFromStyle": access(full(tdsBOMViewerRoles)),
			}
		},
		"ProductSample": {
			"SampleDataSheets": {
				"NewApparelBOM": access(full(tdsBOMCreatorRoles)),
				"NewMaterialBOM": access(full(tdsBOMCreatorRoles))
			}
		},
		"SizeChartAdmin": {
			"CareSymbols": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewCareSymbol": access(full(productSpecLibAdminRoles))
			},
			"CompositionMaterials": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewComposition": access(full(productSpecLibAdminRoles))
			},
			"CompositionPlacements": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewCompositionPlacement": access(full(productSpecLibAdminRoles))
			},
			"DataPackageTemplates": {
				"Copy": access(full(productSpecLibAdminRoles), full(sourcingAdminRoles)),
				"NewDataPackageTemplate": access(full(productSpecLibAdminRoles), full(sourcingAdminRoles))
			},
			"Language": {
				"NewLanguage": access(full(sourcingLibAdminRoles), full(productSpecLibAdminRoles))
			},
			"Libraries": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewLibrary": access(full(productSpecLibAdminRoles))
			},
			"LibrariesLibCareSymbol": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewLibCareSymbol": access(full(productSpecLibAdminRoles))
			},
			"LibrariesLibColorSpecification": {
				"Copy": access(full(colorAdminRoles)),
				"NewLibColorSpecification": access(full(colorAdminRoles))
			},
			"LibrariesLibMaterial": {
				"Copy": access(full(materialLibraryCreatorRoles), full(productSpecLibAdminRoles)),
				"NewLibMaterial": access(full(materialLibraryCreatorRoles), full(productSpecLibAdminRoles)),
			},
			"LibrariesLibPrintDesign": {
				"Copy": access(full(colorAdminRoles)),
				"NewLibPrintDesign": access(full(colorAdminRoles))
			},
			"LibrariesLibSizeLabel": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"NewLibSizeLabel": access(full(productSpecLibAdminRoles))
			},
			"Placement": {
				"Copy": access(full(productSpecLibAdminRoles)),
				"MoveDown": access(full(productSpecLibAdminRoles)),
				"MoveUp": access(full(productSpecLibAdminRoles)),
				"NewPlacement": access(full(productSpecLibAdminRoles))
			}
		},
		"SKUMaterial": {
			"SOLineItems": {
				"NewSOLineItem": access(full(soRequesterRoles))
			}
		},
	});
});